import {IGaritaResponse} from '../modelos/IMantGarita';
import {Observable} from 'rxjs';
import {CommonService} from './../../../shared/utils/common.service';
import {UtilsService} from './../../../shared/utils/utils.service';
import {Injectable} from '@angular/core';
import {moduloGaritas} from '../diccionarios/balanzaModulo.js';

@Injectable({
  providedIn: 'root',
})
export class MantenimientoGaritasService {
  private diccionarioModulo: any;
  private url: string;

  constructor(private _util: UtilsService, private _commom: CommonService) {
    this.diccionarioModulo = moduloGaritas;
    this.url = this._util.getUrlBascula();
  }

  obtener(): Observable<IGaritaResponse[]> {
    return this._commom.peticionGetConHeader(
      this.url + this.diccionarioModulo.url.mantenimientoGaritas.obtenerTodo
    );
  }

  obtenerPorId(idGarita: number): Observable<IGaritaResponse> {
    return this._commom.peticionGetConHeader(
      this.url +
      this.diccionarioModulo.url.mantenimientoGaritas.obtenerPorId +
      idGarita
    );
  }

  crear(request: IGaritaResponse) {
    return this._commom.peticionPostConHeader(
      this.url + this.diccionarioModulo.url.mantenimientoGaritas.crear,
      request
    );
  }

  actualizar(request: IGaritaResponse): Observable<any> {
    return this._commom.peticionPutConHeader(
      this.url + this.diccionarioModulo.url.mantenimientoGaritas.actualizar,
      request
    );
  }

  borrar(idGarita: number): Observable<any> {
    return this._commom.peticionDeleteConHeader(
      this.url +
      this.diccionarioModulo.url.mantenimientoGaritas.eliminar +
      idGarita
    );
  }
}
